/**
 * Нормализация mediaUrl трека: сервер может вернуть абсолютный URL,
 * путь от корня или голый ID файла — приводим к рабочему виду
 * для загрузки аудио плеером (плеер добавляет только origin хоста,
 * путь /api/... должен быть в значении).
 *
 * Важно: старый общий эндпойнт /api/files/{id}/download отдаёт файл
 * только его владельцу (403 для остальных), поэтому для аудио
 * переписываем его на специализированный /api/files/download/audio/{id}.
 *
 * @param {string} value - Значение mediaUrl с сервера
 * @param {string} [fileId] - ID файла (fallback, если mediaUrl пустой)
 * @returns {string|null} Нормализованный URL или null
 */
export const normalizeMediaUrl = (value, fileId) => {
  if (value) {
    if (/^https?:\/\//i.test(value)) {
      // Абсолютный URL со старым путём скачивания — переписываем на аудио-эндпойнт
      const absoluteMatch = value.match(/^https?:\/\/[^/]+\/api\/files\/([0-9a-f-]{36})\/download$/i);
      if (absoluteMatch) return `/api/files/download/audio/${absoluteMatch[1]}`;
      return value;
    }
    if (value.startsWith('/')) {
      // Старый общий путь скачивания файла — переписываем на аудио-эндпойнт
      const pathMatch = value.match(/^\/api\/files\/([0-9a-f-]{36})\/download$/i);
      if (pathMatch) return `/api/files/download/audio/${pathMatch[1]}`;
      return value;
    }
    // Голый ID файла — используем эндпоинт скачивания аудио
    return `/api/files/download/audio/${value}`;
  }
  if (fileId) {
    return `/api/files/download/audio/${fileId}`;
  }
  return null;
};
